import { render, staticRenderFns } from "./RelatedDocuments.vue?vue&type=template&id=c013248c&scoped=true&lang=pug&"
import script from "./RelatedDocuments.vue?vue&type=script&lang=ts&"
export * from "./RelatedDocuments.vue?vue&type=script&lang=ts&"
import style0 from "./RelatedDocuments.vue?vue&type=style&index=0&id=c013248c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c013248c",
  null
  
)

export default component.exports